export class Menu {
    url: string;
    title: string;
    icon: string;
    showDivider: boolean;

    constructor(url: string, title: string, icon: string, showDivider: boolean = false) {
        this.url = url;
        this.title = title;
        this.icon = icon;
        this.showDivider = showDivider;
    }
}